import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/macro';

import './organise-class-groups-modal.scss';

import ThreeEssentailsButton from '../../../three-essentails-button/three-essentails-button';

function OrganiseClassGroupsModal({
    title,
    description,
    closeHandler,
    containerStyle,
    clickHandler,
    classroomId
}) {
    const continueClickHandler = () => {
        clickHandler({ classId: classroomId });
    };

    const modalTemplate = (
        <aside className="modal__overlay">
            <div
                style={{ ...containerStyle }}
                className={'modal modal--floating'}>
                {
                    <div>
                        <div className="modal__header">
                            <h2 className="modal__title">{title}</h2>
                        </div>
                        <h2 className="modal__description">{description}</h2>
                        <h2 className="modal__button-container">
                            <ThreeEssentailsButton
                                clickHandler={closeHandler}
                                title={<Trans id="Modal - Cancel" />}
                                show3EIcon={false}
                                showArrow={false}
                                buttonClassName={'modal__button-container__button-style'} />
                            <ThreeEssentailsButton
                                clickHandler={continueClickHandler}
                                title={<Trans id="Modal - Continue" />}
                                show3EIcon={false}
                                showArrow={false}
                                buttonClassName={'modal__button-container__button-style'} />
                        </h2>
                    </div>
                }
            </div>
        </aside>
    );

    return modalTemplate;
}

OrganiseClassGroupsModal.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    closeHandler: PropTypes.func.isRequired,
    clickHandler: PropTypes.func.isRequired,
    containerStyle: PropTypes.object,
    classroomId: PropTypes.number.isRequired
};

export default OrganiseClassGroupsModal;



// WEBPACK FOOTER //
// ./components/one-roster-organise-class-groups/components/organise-class-groups-modal/organise-class-groups-modal.js